import { useState } from "react";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import toast from "react-hot-toast";

export const useOrderManagment = () => {
  const [allBranch, setAllBranch] = useState([]);
  const [allZone, setAllZone] = useState([]);
  const [allVendor, setAllVendor] = useState([]);
  const [allDriver, setAllDriver] = useState([]);
  const [allDropzone, setAllDropzone] = useState([]);

  const getAllBranch = async () => {
    try {
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_BRANCH,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse.data) {
        let data = apiResponse?.data?.data?.map((item) => {
          return {
            id: item?.id,
            name: item?.name,
            address: item?.address,
          };
        });
        setAllBranch(data || []);
      } else setAllBranch([]);
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllZone = async () => {
    try {
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_ZONE,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse.data) {
        let data = apiResponse?.data?.data?.map((item) => {
          return {
            id: item?.id,
            name: item?.name,
          };
        });
        setAllZone(data || []);
      } else setAllZone([]);
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllVendor = async () => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_MODIFIERES.GET_ALL_VENDOR_LIST,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse.data) {
        // apiResponse.data = [
        //   { id: "", vendorDetail: {storeName:'All'} },
        //   ...apiResponse.data,
        // ];
        let data = apiResponse?.data?.map((item) => {
          return {
            id: item?.id,
            name: item?.vendorDetail?.storeName, //item?.firstName + " " + item.lastName,
          };
        });
        setAllVendor(data);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllDriver = async () => {
    try {
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_DRIVER_LIST,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse.data) {
        let data = apiResponse?.data?.map((item) => {
          return {
            id: item?.id,
            name: item?.firstName + " " + item.lastName,
          };
        });
        setAllDriver(data);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getAllDropzone = async () => {
    try {
      let response = await globalRequest(
        Apis.ORDERS.GET_ALL_DROPZONE,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (apiResponse.data) {
        let data = apiResponse?.data?.map((item) => {
          return {
            id: item?.id,
            name: item?.dropZoneLocales[0]?.name,
          };
        });
        setAllDropzone(data);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  return {
    getAllBranch,
    allBranch,
    getAllZone,
    allZone,
    getAllVendor,
    allVendor,
    getAllDriver,
    allDriver,
    getAllDropzone,
    allDropzone,
  };
};
